module.exports = __webpack_public_path__ + "img/ex_title.7ea5f880.png";